import {
  useMutation,
  type UseMutationOptions
} from '@tanstack/react-query';
import { useApiClient } from '@api-client/context';
import type { SavedFilter, SavedFilterPayload } from './index';

export function useCreateOrUpdateSavedFilterMutation(
  options?: UseMutationOptions<SavedFilter, Error, SavedFilterPayload>
) {
  const api = useApiClient();

  return useMutation({
    mutationFn: (payload) => api.savedFilters.createOrUpdate(payload),
    ...options
  });
}

export function useDeleteSavedFilterMutation(
  options?: UseMutationOptions<void, Error, number>
) {
  const api = useApiClient();

  return useMutation({
    mutationFn: (id) => api.savedFilters.delete(id),
    ...options
  });
}
